import request from '@/config/axios'

export interface TradeInvoiceVO {
  id?: number
  userId?: number
  orderId?: number
  orderNo?: string
  price?: number
  titleType?: number
  title?: string
  taxNo?: string
  email?: string
  bankName?: string
  bankAccount?: string
  companyAddress?: string
  companyPhone?: string
  status?: number
  invoiceNo?: string
  invoiceUrl?: string
  adminRemark?: string
  issueTime?: string
  rejectReason?: string
  createTime?: string
}

export const getInvoicePage = (params: any) => {
  return request.get({ url: '/trade/invoice/page', params })
}

export const getInvoice = (id: number) => {
  return request.get({ url: '/trade/invoice/get?id=' + id })
}

export const issueInvoice = (data: {
  id: number
  invoiceNo?: string
  invoiceUrl?: string
  adminRemark?: string
}) => {
  return request.put({ url: '/trade/invoice/issue', data })
}

export const rejectInvoice = (data: { id: number; rejectReason: string }) => {
  return request.put({ url: '/trade/invoice/reject', data })
}
